<template>
  <div>
    <vs-popup
      :title="
        model.code
          ? $t('EditDeductionAndIncrease')
          : $t('CreateDeductionAndIncrease')
      "
      :active.sync="showModal"
    >
      <form>
        <div class="vx-col w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.title"
            name="title"
            :label="$t('Title')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('title')">{{
            errors.first("title")
          }}</span>
        </div>
        <div class="vx-col w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.amount"
            name="amount"
            :label="$t('Amount')"
            v-validate="{ required: true }"
          />
          <span class="text-danger text-sm" v-show="errors.has('amount')">{{
            errors.first("amount")
          }}</span>
        </div>

        <div class="vx-col w-full" v-if="model.code && load">
          <label class="vs-select--label">{{ $t("ToleranceType") }}</label>
          <v-select
            label="name"
            name="tolerance"
            :options="toleranceTypes"
            :value="toleranceValue"
            @input="toleranceTypeSelected"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            class="mb-2"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('tolerance')">{{
            errors.first("tolerance")
          }}</span>
        </div>
        <div class="vx-col w-full" v-if="!model.code">
          <label class="vs-select--label">{{ $t("ToleranceType") }}</label>
          <v-select
            label="name"
            name="toleranceType"
            :options="toleranceTypes"
            v-model="model.toleranceType"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            ref="toleranceSelected"
            class="mb-2"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('tolerance')">{{
            errors.first("tolerance")
          }}</span>
        </div>
        <div class="vx-col w-full mt-4">
          <vs-button
            type="filled"
            class="float-right mb-4"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    title: {
      required: "لطفا عنوان موردنظر را وارد نمایید.",
    },
    amount: {
      required: "لطفا مقدار موردنظر را وارد نمایید.",
    },
    tolerance: {
      required: "لطفا نوع عملیات موردنظر را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_DeducationIncreasePopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      toleranceTypes: [
        { name: "درصدی", id: 1 },
        { name: "مقداری", id: 2 },
      ],
      disabled: false,
      toleranceValue: "",
      load: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createDeductionIncrease:
        "deductionAndIncrease/createSpecificProductDeductionAndIncrease",
    }),
    toleranceTypeSelected(val) {
      this.model.toleranceType = val;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.createDeductionIncrease(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              setTimeout(() => {
                this.$emit("finish");
                this.model = {};
                this.$validator.reset();
                this.disabled = false;
              }, 0);
            });
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.code) {
          setTimeout(() => {
            this.toleranceValue = this.toleranceTypes.filter(
              (x) => x.id == this.model.toleranceType
            )[0].name;
            this.load = true;
          }, 0);
        } else {
          setTimeout(() => {
            this.$refs.toleranceSelected.clearSelection();
          }, 0);
        }
      } else {
        this.$validator.reset();
        this.disabled = false;
        this.load = false;
      }
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
